<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Scrap Execution" active>

                                <b-row v-if="hasFailedDataScrapExecution">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedScrapExecution.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="scrapExecutionsFailed" :fields="fieldsScrapExecution" :busy="isDataLoading"
                                                         :sort-by.sync="sortByScrapExecution" :sort-desc.sync="sortDescScrapExecution" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(scrapExecutionDate)="row">
													{{ row.item.scrapExecutionDate | moment("DD-MMM-YYYY") }}
												</template>
												<template #cell(beratScrap)="row">
													{{ Number(row.item.beratScrap).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedScrapExecution.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="scrapExecutions" :fields="fieldsScrapExecution" :busy="isDataLoading"
                                                         :sort-by.sync="sortByScrapExecution" :sort-desc.sync="sortDescScrapExecution" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(scrapExecutionDate)="row">
													{{ row.item.scrapExecutionDate | moment("DD-MMM-YYYY") }}
												</template>
												<template #cell(beratScrap)="row">
													{{ Number(row.item.beratScrap).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Scrap Execution Detail" active>

                                <b-row v-if="hasFailedDataScrapExecutionDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedScrapExecutionDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="scrapExecutionDetailsFailed" :fields="fieldsScrapExecutionDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByScrapExecutionDetail" :sort-desc.sync="sortDescScrapExecutionDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(caseQty)="row">
													{{ Number(row.item.caseQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedScrapExecutionDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="scrapExecutionDetails" :fields="fieldsScrapExecutionDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByScrapExecutionDetail" :sort-desc.sync="sortDescScrapExecutionDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(caseQty)="row">
													{{ Number(row.item.caseQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import ScrapExecution from '@/models/ScrapExecution/ScrapExecution';
import ScrapExecutionList from '@/models/ScrapExecution/ScrapExecutionList';
import ScrapExecutionFilter from '@/filters/ScrapExecution/ScrapExecutionFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsScrapExecution: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Customer", key: 'customerCode', sortable: false},
				{"class" : "th-status", "label" : "Scrap Execution Date", key: 'scrapExecutionDate', sortable: false},
				{"class" : "th-status", "label" : "Berat Scrap", key: 'beratScrap', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsScrapExecutionDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Case Number", key: 'controlCardControlCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Case Qty", key: 'caseQty', sortable: false},
				{"class" : "th-status", "label" : "Is Scrap", key: 'isScrap', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			scrapExecutions : [],
			scrapExecutionsFailed: [],
			scrapExecutionId : '',
			sortByScrapExecution: '',
			sortDescScrapExecution: '',
			hasFailedDataScrapExecution: false,
			totalFailedScrapExecution: 0,
			totalSucceedScrapExecution: 0,
			scrapExecutionDetails : [],
			scrapExecutionDetailsFailed: [],
			scrapExecutionDetailId : '',
			sortByScrapExecutionDetail: '',
			sortDescScrapExecutionDetail: '',
			hasFailedDataScrapExecutionDetail: false,
			totalFailedScrapExecutionDetail: 0,
			totalSucceedScrapExecutionDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('scrapexecution/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('scrapexecution/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getScrapExecutionForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getScrapExecutionForUpload : async function() {
			let _this = this;
			this.$http.get('scrapexecution/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.scrapExecutions = [];
_this.scrapExecutionDetails = [];


					if (response != null) {
						let result = response.data;
						_this.scrapExecutions = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedScrapExecution = _this.scrapExecutions.length;

						_this.scrapExecutionsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataScrapExecution = true;
						_this.totalFailedScrapExecution = 0;
						if(_this.scrapExecutionsFailed == undefined || _this.scrapExecutionsFailed.length === 0) _this.hasFailedDataScrapExecution = false;
						if(_this.hasFailedDataScrapExecution) _this.totalFailedScrapExecution = _this.scrapExecutionsFailed.length;
						_this.scrapExecutionDetails = [];
						_this.scrapExecutionDetailsFailed = [];
						_this.hasFailedDataScrapExecutionDetail = true;
						_this.totalSucceedScrapExecutionDetail = 0;
						result.forEach(function(element) {
							_this.scrapExecutionDetails.push(...element.scrapExecutionDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedScrapExecutionDetail = _this.scrapExecutionDetails.length;

							_this.scrapExecutionDetailsFailed.push(...element.scrapExecutionDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.scrapExecutionDetailsFailed == undefined || _this.scrapExecutionDetailsFailed.length === 0) _this.hasFailedDataScrapExecutionDetail = false;
							if(_this.hasFailedDataScrapExecutionDetail) _this.totalFailedScrapExecutionDetail = _this.scrapExecutionDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'scrapexecution/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'ScrapExecution.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterScrapExecution = new ScrapExecutionFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
